import { readXlsxFile } from "./xlsx"

export type BoothData = {
  "祭典名": string
  "No.": number
  "団体名": string
  "企画名": string
  "概要": string
  "分類": string
  "建物名": string
  "部屋・フロア": string
  "時間(土曜)": string
  "時間(日曜)": string
  "ID": string
}

export const BoothColors: Record<string, string> = {
  "課外活動展": "#ED7B7E",
  "文学部展": "#BA9A7C",
  "収穫祭・農学部展": "#87C57A",
  "テクノフェスタ・工学部展": "#76A1D6",
  "経営学部展": "#AADBE2",
  "教育学部展": "#009FB6",
  "芸術学部展": "#CBA0C8",
  "リベラルアーツ学部展": "#EF8FB5",
  "観光学部展": "#F8CD7E",
  "研究所": "#7A9A4F",
  "大学関連団体": "#FAEE00",
}

export function toBooth(org: string, data: Record<string, unknown>) {
  const booth: Record<keyof BoothData, unknown> = {
    "祭典名": org,
    "No.": data["No."],
    "団体名": data["(1) 団体名"] || "",
    "企画名": data["(2) 企画名：20文字以内"] || "",
    "概要": data["(3) 企画概要：80文字以内"],
    "分類": data["(4) 企画分類"],
    "建物名": data["(6-1) 建物名"] || "",
    "部屋・フロア": (data["(6-2) フロア・教室"] as string || ""),
    "時間(土曜)": (data["(7) 実施日時"] as string || "").match(/(?<=(\(|（)土(\)|）)(：|:)\s*).+/)?.[0] ?? "×",
    "時間(日曜)": (data["(7) 実施日時"] as string || "").match(/(?<=(\(|（)日(\)|）)(：|:)\s*).+/)?.[0] ?? "×",
    "ID": org + "-" + data["No."],
  }
  return booth as BoothData
}

export async function fetchBooths(org: string) {
  const records = await readXlsxFile(`/data/booth/${org}.xlsx`, "シート1")
  const booths = records.map((record) => toBooth(org, record))
  return booths
}
